import {useEffect} from 'react';

function useDocSetup(docTitle) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = docTitle + ' • BienesMart📦';
  }, [docTitle]);
}

export default useDocSetup;
